import { useQuery } from '@tanstack/react-query';
import { fetchCompanyFeatures, type CompanyFeatures } from '../api/leadMove';

const NONE: CompanyFeatures = { leadMove: false, cardImages: false };

/**
 * Staff-granted portal features for the caller's company. FAIL-CLOSED: while
 * loading, or on any error, everything reads as off. Hiding an action is UX
 * only — the backend refuses a gated route with FEATURE_DISABLED regardless.
 */
export function useCompanyFeatures(): CompanyFeatures {
  const { data } = useQuery({
    queryKey: ['companyFeatures'],
    queryFn: fetchCompanyFeatures,
    staleTime: 60_000,
  });
  return data ?? NONE;
}
